import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import { useDispatch } from "react-redux";
import moment from "moment";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import localImages from "../Constant/localImages";

interface props {
  open: boolean;
  data?: any;
  handlePrintClose: Function;
}

export default function DispatchOrderPrint(props: props) {
  const dispatch = useDispatch();
  var converter = require("number-to-words");

  const { handlePrintClose } = props;
  useEffect(() => { }, []);

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modelChat"
        open={props.open}
        onClose={() => handlePrintClose()}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          <div className="dispachModeldiv p-3 col-md-8">
            <div className="text-end mb-2">
              <HighlightOffIcon
                color="primary"
                className="cursor"
                onClick={() => handlePrintClose()}
              />{" "}
            </div>
            {props?.data?.map((item: any, index: any) => {
              return (
                <div key={index} className="d-flex pb-2 flex-wrap">
                  <div className="col-12 border border-secondary">
                    <div className="p-3 mb-2">
                      <div className="py-3 border text-center">
                        <div className="pb-2">
                          <span
                            className="fw-bold"
                            style={{ fontSize: "15px" }}
                          >
                            Indian Post
                          </span>
                        </div>
                        <span className="fw-bold" style={{ fontSize: "12px" }}>
                          BUSINESS PARCEL
                        </span>
                        <br />
                        <span
                          className="fw"
                          style={{ color: "#1C1C1C", fontSize: "12px" }}
                        >
                          PUNE CITY WEST DIVISION,BOOKING UNDER ADVANCE PAYMENT
                        </span>
                        <span
                          className="fw d-block"
                          style={{ color: "#1C1C1C", fontSize: "12px" }}
                        >
                          Advance Payment Customer No. :-20008
                        </span>
                      </div>
                      <div className=" py-3 border text-center">
                        <div className="pb-2">
                          <span
                            className="fw-bold"
                            style={{ fontSize: "15px" }}
                          >
                            Shipping Address
                          </span>
                        </div>
                        <span
                          className="fw"
                          style={{ color: "#1C1C1C", fontSize: "12px" }}
                        >
                          {item?.address?.line1}, {item?.address?.line2},
                        </span>
                        <br />
                        <span className="fw-bold" style={{ fontSize: "12px" }}>
                          {item?.address?.landmark}
                        </span>
                        <br />
                        <span
                          className="fw"
                          style={{ color: "#1C1C1C", fontSize: "12px" }}
                        >
                          {item?.address?.city},{" "}
                          {item?.address?.state},{" "}
                          {item?.address?.pincode}
                        </span>
                        <br />
                        <span
                          className="fw"
                          style={{ color: "#1C1C1C", fontSize: "12px" }}
                        >
                          {/* {item?.address?.landmark} */}
                        </span>
                        <br />
                        <span
                          className="fw"
                          style={{ color: "#1C1C1C", fontSize: "12px" }}
                        >
                          Phone Number: +91-{item?.users?.mobileNo}
                        </span>
                        {item?.address?.alternatePhoneNumber ? (
                          <>
                            <br />
                            <span
                              className="fw"
                              style={{ color: "#1C1C1C", fontSize: "12px" }}
                            >
                              Alternate Phone Number: +91-
                              {item?.address?.alternatePhoneNumber}
                            </span>
                          </>
                        ) : null}
                      </div>
                      <div className="py-3 border text-center">
                        <div className="pb-2">
                          <span
                            className="fw-bold"
                            style={{ fontSize: "15px" }}
                          >
                            Sender Address
                          </span>
                        </div>
                        <span className="fw-bold" style={{ fontSize: "12px" }}>
                          TWO BROTHERS PUBLICATIONS PRIVATE LIMITED
                        </span>
                        <br />
                        <span
                          className="fw"
                          style={{ color: "#1C1C1C", fontSize: "12px" }}
                        >
                          2Nd Floor, Shivranjan Complex, Someshwar Wadi,
                        </span>
                        <br />
                        <span
                          className="fw"
                          style={{ color: "#1C1C1C", fontSize: "12px" }}
                        >
                          In Front Of Pawana Sahkari Bank, Baner Rd, Near
                          Rajwada Hotel,
                        </span>
                        <br />
                        <span
                          className="fw"
                          style={{ color: "#1C1C1C", fontSize: "12px" }}
                        >
                          Pune, Maharashtra, 411008
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 border border-secondary">
                    <div className="p-3">
                      <span
                        className="d-flex justify-content-end"
                        style={{
                          fontSize: "7px",
                        }}
                      >
                        Original For Buyer
                      </span>
                      <div
                        className="p-3"
                        style={{ position: "relative", top: "-10px" }}
                      >
                        <div className="text-center p-1">
                          <div className="">
                            <img
                              style={{
                                width: "100px",
                                height: "100px",
                                position: "relative",
                                top: "-11px",
                                left: "-7px",
                              }}
                              src={localImages?.logoVerticle}
                            ></img>
                          </div>
                          <span className="text-center">
                            <p
                              style={{
                                fontSize: "11px",
                                marginTop: "5px"
                              }}
                            >
                              2Nd Floor, Shivranjan Complex, Someshwar Wadi, In
                              Front Of Pawana Sahkari Bank, Baner Rd, Near
                              Rajwada Hotel, Pune, Maharashtra 411008
                            </p>
                          </span>
                        </div>
                        <div
                          className="d-flex justify-content-center"
                          style={{ position: "relative", top: "-10px", marginBottom: "10px" }}
                        >
                          <span
                            style={{ marginRight: "1%" }}
                          >
                            <b style={{color:"#f15822"}}>Email:</b> accounts@ifasonline.com{" "}
                          </span>
                          <span
                          // style={{
                          //   paddingbottom: "10px",
                          //   textalign: "right",
                          //   fontSize: "7px",
                          //   marginLeft: "16px",
                          //   marginRight: "25px",
                          // }}
                          >
                            <b style={{color:"#f15822"}}>Phone No.:</b> +91-9876543219
                          </span>
                        </div>
                        <div
                          style={{
                            position: "relative",
                            top: "-8px",
                            width: "100%",
                            marginBottom: "1%",
                            border: "solid 1px  #244394"
                          }}
                        ></div>
                      </div>
                      <div
                        className="m-1 d-flex"
                        style={{ position: "relative", top: "-28px", border: "solid 1px  #244394" }}
                      >
                        <div
                          className="pt-2 col-6"
                          style={{
                            paddingInlineStart: "28px",
                            fontSize: "7px",
                          }}
                        >
                          <div>
                            <span> Order No : </span>{" "}
                            {/* <span>{item?.orderNo}</span> */}
                          </div>
                          <div>
                            <span>Date of Invoice : </span>{" "}
                            <span>
                              {moment.utc(item?.date).format("DD-MM-YYYY")}
                            </span>
                          </div>
                          <div>
                            <span>State & State Code : </span>{" "}
                            <span>{`${item?.address?.state} (${item?.address?.state?.gstCode})`}</span>
                          </div>
                        </div>
                        <div className="p-2 col-6" style={{ fontSize: "7px" }}>
                          <div>
                            <span>Place of Supply : </span>{" "}
                            <span>{`${item?.address?.state} (${item?.address?.state?.gstCode})`}</span>
                          </div>
                          <div>
                            <span>Order ID : </span>{" "}
                            <span>{item?.orderNo}</span>
                          </div>
                          <div>
                            <span>Reverse Charge : </span> <span>N</span>
                          </div>
                        </div>
                      </div>
                      <span>
                        <span
                          className="fw-bold"
                          style={{
                            fontSize: "8px",
                            paddingInlineStart: "4px",
                            position: "relative",
                            top: "-28px",
                          }}
                        >
                          Billed to :
                        </span>
                      </span>
                      <div
                        className="m-1 d-flex"
                        style={{ position: "relative", top: "-28px", border: "solid 1px  #244394" }}
                      >
                        <div
                          className="pt-2 pb-2 col-6"
                          style={{
                            paddingInlineStart: "28px",
                            fontSize: "7px",
                          }}
                        >
                          <div>
                            <span>Name : </span>{" "}
                            <span>{`${item?.users?.firstName} ${item?.users?.lastName}`}</span>
                          </div>
                          <div>
                            <span>Address : </span>{" "}
                            <span>{`${item?.address?.line1}, ${item?.address?.line2}, ${item?.address?.landmark}, ${item?.address?.city}, `}</span>
                            <span>{`${item?.address?.state}, ${item?.address?.state?.countryISO2} - ${item?.address?.pincode}`}</span>
                          </div>
                        </div>
                        <div className="p-2 col-6" style={{ fontSize: "7px" }}>
                          <div>
                            <span>Mobile No : </span>{" "}
                            <span>{item?.users?.mobileNo}</span>
                          </div>
                          <div>
                            <span>Email : </span>{" "}
                            <span>{item?.users?.email}</span>
                          </div>
                        </div>
                      </div>
                      <div
                        className="m-1"
                        style={{ position: "relative", top: "-25px", border: "solid 1px #244394" }}
                      >
                        <table style={{ width: "100%" }}>
                          <thead>
                            <tr
                              style={{
                                padding: "5px",
                                fontSize: "7px",
                              }}
                            >
                              <th style={{ backgroundColor: "#244394", color: "#fff" }}>
                                S.N.
                              </th>
                              <th style={{ backgroundColor: "#244394", color: "#fff" }}>
                                Product Name
                              </th>
                              <th style={{ backgroundColor: "#244394", color: "#fff" }}>
                                Quantity
                              </th>
                              {/* <th style={{ backgroundColor: "#244394", color: "#fff" }}>
                                HSN
                              </th> */}
                              <th style={{ backgroundColor: "#244394", color: "#fff" }}>
                                Tax Rate
                              </th>
                              <th style={{ backgroundColor: "#244394", color: "#fff" }}>
                                Amount
                              </th>
                              <th style={{ backgroundColor: "#244394", color: "#fff" }}>
                                Total Amount
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {item?.products?.map(
                              (subItem: any, subIndex: any) => {
                                return (
                                  <tr
                                    key={subIndex}
                                    style={{ padding: "5px", fontSize: "7px" }}
                                  >
                                    <td>{subIndex + 1}</td>
                                    <td>{subItem?.name}</td>
                                    <td>{subItem?.quantity}</td>
                                    {/* <td>{item?.HSN?.offerPrice}</td> */}
                                    <td></td>
                                    <td>{subItem?.offerPrice}</td>
                                    <td>{subItem?.quantity * subItem?.offerPrice}</td>
                                  </tr>
                                );
                              }
                            )}
                            <tr style={{ padding: "5px", fontSize: "7px" }}>
                              <td colSpan={2}></td>
                              <td>
                                <span className="fw-bold">Other Charges</span>
                              </td>
                              <td>
                                <span className="fw-bold">
                                  Packaging & Delivery Fee
                                </span>
                              </td>
                              <td>
                                <span className="fw-bold">
                                  {item?.deliveryFee}
                                </span>
                              </td>
                            </tr>
                            <tr style={{ padding: "5px", fontSize: "7px" }}>
                              <td colSpan={2}></td>
                              <td>
                                <span className="fw-bold">Discount</span>
                              </td>
                              <td>
                                <span className="fw-bold">
                                  {/* {item?.courses[0]?.discPer} % */}
                                </span>
                              </td>
                              <td>
                                <span className="fw-bold">
                                  {/* {item?.courses[0]?.discountedPrice} */}
                                </span>
                              </td>
                            </tr>
                            <tr style={{ padding: "5px", fontSize: "7px" }}>
                              <td colSpan={2}></td>
                              <td>
                                <span className="fw-bold">Grand Total</span>
                              </td>
                              <td>
                                <span className="fw-bold"></span>
                              </td>
                              <td>
                                <span className="fw-bold">
                                  {item?.totalOfferPrice}
                                </span>
                              </td>
                            </tr>
                            <tr style={{ padding: "5px" }}>
                              <td colSpan={5}>
                                <span
                                  className="fw-bold"
                                  style={{ fontSize: "6px" }}
                                >
                                  Amount Chargeable(In Words)
                                </span>
                                <br></br>
                                <span
                                  className="fw-bold"
                                  style={{ fontSize: "7px" }}
                                >
                                  INR{" "}
                                  {converter
                                    .toWords(item?.totalOfferPrice)
                                    .toUpperCase()}{" "}
                                  Only
                                </span>
                              </td>
                            </tr>
                            <tr style={{ padding: "5px" }}>
                              <td colSpan={5}>
                                <span
                                  className="fw-bold"
                                  style={{ fontSize: "6px" }}
                                >
                                  Tax Amount(In Words)
                                </span>
                                <br></br>
                                <span
                                  className="fw-bold"
                                  style={{ fontSize: "7px" }}
                                >
                                  INR Zero Only
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        className="m-1"
                        style={{ position: "relative", top: "-26px", border:"solid 1px #244394"}}
                      >
                        <span
                          className="p-2 fw-bold"
                          style={{ color: "#f15822", fontSize: "9px" }}
                        >
                          Terms & Condition
                        </span>
                        <ul style={{ fontSize: "6px" }}>
                          <li>
                            If You Purchase The Study Material Then The Order
                            Will Be Delivered In 15 Working Days.
                          </li>
                          <li>
                            Once An Order Is Placed You Can Not Cancel The Order
                            And Have No Refund For The Same.
                          </li>
                          <li>
                            All Legal Disputes Are Subject To The Jurisdiction
                            Of The Courts / Authorities Of Jodhpur, Rajasthan
                            Only.
                          </li>
                        </ul>
                      </div>
                      <div className="text-center">
                        <span
                          className="fw-bold"
                          style={{
                            fontSize: "6px",
                          }}
                        >
                          This is a Computer Generated Invoice
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 border border-secondary">
                    <div className="p-3">
                      <div
                        className="m-1 w-100 d-flex"
                        style={{
                          borderStyle: "dashed",
                          borderColor: "#707070",
                        }}
                      ></div>
                      <table style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th
                              style={{
                                backgroundColor: "#353535",
                              }}
                            >
                              For Office Purpose :{" "}
                            </th>
                          </tr>
                        </thead>
                      </table>
                      <div className="pt-2 pb-2">
                        {/* {item?.courses?.map((data: any) => {
                          return data?.booksList?.map(
                            (subItem: any, subIndex: any) => (
                              <span key={subIndex} className="px-2">
                                <img
                                  style={{
                                    width: "59px",
                                    height: "59px",
                                    marginBottom: "10px",
                                  }}
                                  src={subItem?.coverImage}
                                ></img>
                              </span>
                            )
                          );
                        })} */}
                      </div>
                      <div
                        className="m-1 w-100 d-flex"
                        style={{
                          borderStyle: "dashed",
                          borderColor: "#707070",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Fade>
      </Modal>
    </>
  );
}
